import React from "react";
import "../Css/DaimondBanner.css";
import preciselyCalibrated from "../Assets/daimondBannerImg/precisely-calibrated.png";
import noMinimumOrderQuantity from "../Assets/daimondBannerImg/no-minimum-order-quantity.png";
import natural from "../Assets/daimondBannerImg/natural.png";
import standardAssorted from "../Assets/daimondBannerImg/standardAssorted.png";
import globalAndSecureShipment from "../Assets/daimondBannerImg/globalAndSecureShipment.png";
import { Fade } from "react-awesome-reveal";

const DaimondBanner = () => {
  return (
    <>
      <section className="DaimondBanner-main-flex-sec">
        <div className="container">
          <div className="DaimondBanner-main-flex">
            <Fade triggerOnce direction="up">
              <div className="DaimondBanner-main-flex-col">
                <div>
                  <img
                    className="DaimondBanner-main-flex-img"
                    alt="Best Diamond Dealer"
                    src={preciselyCalibrated}
                  />
                </div>
                <h5>precisely calibrated </h5>
              </div>
            </Fade>
            <Fade triggerOnce direction="up">
              <div className="DaimondBanner-main-flex-col">
                <div>
                  <img
                    className="DaimondBanner-main-flex-img"
                    alt="Best Diamond Dealer"
                    src={noMinimumOrderQuantity}
                  />
                </div>
                <h5>
                  no minimum order quantity
                </h5>
              </div>
            </Fade>
            <Fade triggerOnce direction="up">
              <div className="DaimondBanner-main-flex-col">
                <div>
                  <img className="DaimondBanner-main-flex-img"
                  alt="Best Diamond Dealer" src={natural} />
                </div>
                <h5>
                  100% natural
                </h5>
              </div>
            </Fade>
            <Fade triggerOnce direction="up">
              <div className="DaimondBanner-main-flex-col">
                <div>
                  <img
                    className="DaimondBanner-main-flex-img"
                    alt="Best Diamond Dealer"
                    src={standardAssorted}
                  />
                </div>
                <h5>
                  standard assortment
                </h5>
              </div>
            </Fade>
            <Fade triggerOnce direction="up">
              <div className="DaimondBanner-main-flex-col">
                <div>
                  <img
                    className="DaimondBanner-main-flex-img"
                    alt="Best Diamond Dealer"
                    src={globalAndSecureShipment}
                  />
                </div>
                <h5>
                  global and secure
                  shipment
                </h5>
              </div>
            </Fade>
          </div>
        </div>
      </section>
    </>
  );
};

export default DaimondBanner;
